import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installAuthFetch } from './utils/apiFetch';

// Attach the stored token to same-origin /api requests before anything renders,
// so no call can race ahead of it unauthenticated.
installAuthFetch();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
